import HttpHandler from "./HttpHandler";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const http = new HttpHandler({ baseUrl: API_URL }, { axios });

export function setUpUnauthorizedInterceptor(onUnauthorized) {
  http.axios.interceptors.response.use(
    (r) => r,
    (e) => {
      if (e.response?.status === 401) onUnauthorized();
      return Promise.reject(e);
    }
  );
}
